export default "/images/6e21abf05762854bf316803a25a91cc1.avif";